export function ConciergeIcon() {
  return (
    <svg
      className="omni-image"
      preserveAspectRatio="xMidYMid meet"
      height="150"
      width="150"
      viewBox="-0.04 0 324.31 263.59"
      role="presentation"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M219.77 262.09h-218L-.04 93.23 110.75 0l109 93Zm-211-7h204V96.2l-102-87L7.06 96.47Z"
          fill="#d0af99"
          data-color="1"
        />
        <path
          fill="#eaead9"
          d="M324.27 233.59c0 16.569-13.431 30-30 30s-30-13.431-30-30 13.431-30 30-30 30 13.431 30 30"
          data-color="2"
        />
        <path
          fill="#eaead9"
          d="M324.27 131.59c0 16.569-13.431 30-30 30s-30-13.431-30-30 13.431-30 30-30 30 13.431 30 30"
          data-color="2"
        />
      </g>
    </svg>
  );
}